import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import MagicConsume from "@/pages/MagicConsume";
import MemberHome from "@/pages/MemberHome";
import RegisterActivity from "@/pages/RegisterActivity";
import MyStatistics from "@/pages/MyStatistics";
import History from "@/pages/History";
import Profile from "@/pages/Profile";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminOrganizations from "@/pages/admin/AdminOrganizations";
import AdminLocations from "@/pages/admin/AdminLocations";
import AdminActivityTypes from "@/pages/admin/AdminActivityTypes";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminTargets from "@/pages/admin/AdminTargets";
import AdminReports from "@/pages/admin/AdminReports";
import AdminWeeklyReport from "@/pages/admin/AdminWeeklyReport";
import AdminOrgDetail from "@/pages/admin/AdminOrgDetail";

function RoleRoot() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Laddar…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "central_admin" || user.role === "local_admin") return <Navigate to="/admin" replace />;
  return <Navigate to="/hem" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="bottom-center" richColors />
        <Routes>
          <Route path="/" element={<RoleRoot />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registrera-konto" element={<Register />} />
          <Route path="/glomt-losenord" element={<ForgotPassword />} />
          <Route path="/aterstall-losenord/:token" element={<ResetPassword />} />
          <Route path="/logga-in/:token" element={<MagicConsume />} />

          <Route path="/hem" element={<ProtectedRoute roles={["member","local_admin","central_admin"]}><MemberHome /></ProtectedRoute>} />
          <Route path="/registrera" element={<ProtectedRoute roles={["member","local_admin","central_admin"]}><RegisterActivity /></ProtectedRoute>} />
          <Route path="/statistik" element={<ProtectedRoute roles={["member","local_admin","central_admin"]}><MyStatistics /></ProtectedRoute>} />
          <Route path="/historik" element={<ProtectedRoute roles={["member","local_admin","central_admin"]}><History /></ProtectedRoute>} />
          <Route path="/profil" element={<ProtectedRoute roles={["member","local_admin","central_admin"]}><Profile /></ProtectedRoute>} />

          <Route path="/admin" element={<ProtectedRoute roles={["central_admin","local_admin"]}><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/kommun/:orgId" element={<ProtectedRoute roles={["central_admin","local_admin"]}><AdminOrgDetail /></ProtectedRoute>} />
          <Route path="/admin/arbetarekommuner" element={<ProtectedRoute roles={["central_admin"]}><AdminOrganizations /></ProtectedRoute>} />
          <Route path="/admin/platser" element={<ProtectedRoute roles={["central_admin","local_admin"]}><AdminLocations /></ProtectedRoute>} />
          <Route path="/admin/aktivitetstyper" element={<ProtectedRoute roles={["central_admin"]}><AdminActivityTypes /></ProtectedRoute>} />
          <Route path="/admin/medlemmar" element={<ProtectedRoute roles={["central_admin","local_admin"]}><AdminUsers /></ProtectedRoute>} />
          <Route path="/admin/mal" element={<ProtectedRoute roles={["central_admin"]}><AdminTargets /></ProtectedRoute>} />
          <Route path="/admin/rapporter" element={<ProtectedRoute roles={["central_admin","local_admin"]}><AdminReports /></ProtectedRoute>} />
          <Route path="/admin/veckorapport" element={<ProtectedRoute roles={["central_admin","local_admin"]}><AdminWeeklyReport /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
